import firedux from '../firedux'
import {getState} from '../store'
import {fromJS} from 'immutable'

import {
  GROUP_CHAT_ENDPOINT
} from '../../config/constants'

import getGroupChatScope from './group_chat_scope'

export default (groupId, scope) => {
  if (!groupId) return Promise.reject('no groupId is given')

  const groupChat = getState().getIn(['groups', 'all', groupId])

  if (groupChat) return Promise.resolve(groupChat)

  return Promise.resolve(scope)
    .then((scope) => scope ? scope : getGroupChatScope(groupId))
    .then((scope) => {
      const ref = firedux.ref.child(GROUP_CHAT_ENDPOINT).child(scope).child(groupId)

      return ref.once('value')
    })
    .then((snapshot) => fromJS(snapshot.val()))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/getters/group_chat.js
 **/